"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.azimuttEmail = void 0;
exports.azimuttEmail = 'contact@azimutt.app';
//# sourceMappingURL=constants.js.map